/**
 * Translated Shipping Policy body.
 * Mirrors the English CMS HTML for page_id "shipping-policy".
 */

const frenchShipping = `
<div class="legal-page container">
      <h1>Informations sur la livraison</h1>
      <p class="last-updated"><em>Dernière mise à jour : octobre 2025</em></p>

      <p class="intro-text">
        Nous expédions partout dans le monde depuis l'île du Cap-Breton, en Nouvelle-Écosse, au Canada. Que vous soyez au Canada, aux États-Unis, en Europe ou ailleurs, nous pouvons vous faire parvenir nos livres et CD de musique celtique pour violon.
      </p>

      <h2>🌍 Destinations</h2>
      <div class="highlight-box">
        <p><strong>Nous livrons partout !</strong> Depuis notre île du Cap-Breton, nous envoyons de la musique celtique à des clients du monde entier.</p>
      </div>

      <h2>⏱️ Délai de traitement</h2>
      <p>
        Les commandes sont généralement préparées et expédiées dans un délai de <strong>2 à 3 jours ouvrables</strong> après confirmation du paiement. Aucune expédition ni livraison les fins de semaine ou les jours fériés.
      </p>
      <div class="info-note">
        <strong>Période de pointe :</strong> en haute saison, le traitement peut prendre un peu plus de temps. Merci de votre patience !
      </div>

      <h2>📦 Délais de livraison</h2>

      <h3>🇨🇦 Canada (intérieur)</h3>
      <div class="info-box">
        <ul>
          <li><strong>Livraison standard :</strong> 5 à 10 jours ouvrables</li>
          <li><strong>Livraison accélérée :</strong> 3 à 5 jours ouvrables (sur demande)</li>
          <li><strong>Livraison gratuite :</strong> pour les commandes de plus de 50 $ CA ✨</li>
        </ul>
      </div>

      <h3>🇺🇸 États-Unis</h3>
      <div class="info-box">
        <ul>
          <li><strong>Livraison standard :</strong> 7 à 14 jours ouvrables</li>
          <li><strong>Livraison accélérée :</strong> 5 à 7 jours ouvrables (sur demande)</li>
        </ul>
      </div>

      <h3>🌍 International</h3>
      <div class="info-box">
        <ul>
          <li><strong>Livraison standard :</strong> 2 à 4 semaines</li>
          <li><strong>Livraison express :</strong> 1 à 2 semaines (sur demande)</li>
        </ul>
      </div>

      <p class="info-note"><em>Note : les délais sont des estimations et peuvent varier selon le lieu, le dédouanement et les retards du transporteur.</em></p>

      <h2>💰 Frais de livraison</h2>
      <p>Les frais sont calculés selon :</p>
      <ul>
        <li>Le pays et la région de destination</li>
        <li>Le poids et les dimensions totaux de la commande</li>
        <li>Le mode choisi (standard ou accéléré)</li>
      </ul>
      <div class="highlight-box">
        <p><strong>🎉 Livraison gratuite !</strong> Profitez de la livraison standard gratuite au Canada pour toute commande de plus de 50 $.</p>
      </div>

      <h2>📫 Confirmation et suivi</h2>
      <p>
        Une fois la commande expédiée, vous recevez un courriel de confirmation avec un numéro de suivi. Vous pouvez suivre le colis en ligne sur le site du transporteur.
      </p>

      <h2>🌐 Notes pour l'international</h2>
      <div class="info-box">
        <h3>Douanes et droits</h3>
        <p>Les clients internationaux sont responsables des droits de douane, taxes ou frais exigés par leur pays. Ces montants ne sont pas inclus dans nos prix ni dans les frais de livraison.</p>

        <h3>Retards douaniers</h3>
        <p>Les envois internationaux peuvent être inspectés et dédouanés, ce qui peut retarder la livraison. Nous ne pouvons ni contrôler ni prévoir ces délais.</p>
      </div>

      <h2>📦 Colis perdus ou endommagés</h2>
      <p>
        Rarement, un colis peut se perdre ou s'endommager en cours de route. Si votre commande n'arrive pas dans le délai prévu, ou si le colis est endommagé, communiquez avec nous immédiatement. Nous travaillerons avec le transporteur pour résoudre le problème.
      </p>

      <h2>📍 Exactitude de l'adresse</h2>
      <div class="info-note">
        <strong>Important :</strong> veuillez vérifier que votre adresse de livraison est exacte et complète. Nous ne sommes pas responsables des commandes envoyées à une adresse erronée fournie par le client. Pour modifier l'adresse, écrivez-nous dès que possible avant l'expédition.
      </div>
    </div>
`;

const germanShipping = `
<div class="legal-page container">
      <h1>Versandinformationen</h1>
      <p class="last-updated"><em>Zuletzt aktualisiert: Oktober 2025</em></p>

      <p class="intro-text">
        Wir versenden weltweit von Cape Breton Island, Nova Scotia, Kanada. Ob Kanada, die Vereinigten Staaten, Europa oder anderswo – wir bringen unsere keltischen Geigenbücher und CDs zu Ihnen.
      </p>

      <h2>🌍 Versandgebiete</h2>
      <div class="highlight-box">
        <p><strong>Wir versenden überallhin!</strong> Von Cape Breton aus liefern wir keltische Musik an Kundinnen und Kunden auf der ganzen Welt.</p>
      </div>

      <h2>⏱️ Bearbeitungszeit</h2>
      <p>
        Bestellungen werden in der Regel innerhalb von <strong>2–3 Werktagen</strong> nach Zahlungseingang bearbeitet und versendet. An Wochenenden und Feiertagen erfolgt kein Versand.
      </p>
      <div class="info-note">
        <strong>Hochsaison:</strong> In Stoßzeiten kann die Bearbeitung etwas länger dauern. Vielen Dank für Ihre Geduld!
      </div>

      <h2>📦 Lieferzeiten</h2>

      <h3>🇨🇦 Kanada (Inland)</h3>
      <div class="info-box">
        <ul>
          <li><strong>Standardversand:</strong> 5–10 Werktage</li>
          <li><strong>Expressversand:</strong> 3–5 Werktage (auf Anfrage)</li>
          <li><strong>Kostenloser Versand:</strong> bei Bestellungen über 50 $ CAD ✨</li>
        </ul>
      </div>

      <h3>🇺🇸 Vereinigte Staaten</h3>
      <div class="info-box">
        <ul>
          <li><strong>Standardversand:</strong> 7–14 Werktage</li>
          <li><strong>Expressversand:</strong> 5–7 Werktage (auf Anfrage)</li>
        </ul>
      </div>

      <h3>🌍 International</h3>
      <div class="info-box">
        <ul>
          <li><strong>Standardversand:</strong> 2–4 Wochen</li>
          <li><strong>Expressversand:</strong> 1–2 Wochen (auf Anfrage)</li>
        </ul>
      </div>

      <p class="info-note"><em>Hinweis: Lieferzeiten sind Schätzungen und können je nach Ort, Zollabfertigung und Transporteur variieren.</em></p>

      <h2>💰 Versandkosten</h2>
      <p>Die Versandkosten richten sich nach:</p>
      <ul>
        <li>Zielland und Region</li>
        <li>Gesamtgewicht und Maßen der Bestellung</li>
        <li>gewählter Versandart (Standard oder Express)</li>
      </ul>
      <div class="highlight-box">
        <p><strong>🎉 Kostenloser Versand!</strong> Kostenloser Standardversand innerhalb Kanadas bei allen Bestellungen über 50 $.</p>
      </div>

      <h2>📫 Versandbestätigung und Sendungsverfolgung</h2>
      <p>
        Nach dem Versand erhalten Sie eine Bestätigungs-E-Mail mit Sendungsnummer. Damit können Sie das Paket auf der Website des Transporteurs verfolgen.
      </p>

      <h2>🌐 Hinweise zum internationalen Versand</h2>
      <div class="info-box">
        <h3>Zoll und Abgaben</h3>
        <p>Internationale Kundinnen und Kunden tragen Zoll, Steuern oder Gebühren ihres Landes. Diese Beträge sind in unseren Preisen und Versandkosten nicht enthalten.</p>

        <h3>Zollverzögerungen</h3>
        <p>Internationale Sendungen können kontrolliert und verzollt werden, was die Lieferung verzögern kann. Solche Verzögerungen können wir weder steuern noch vorhersagen.</p>
      </div>

      <h2>📦 Verlorene oder beschädigte Sendungen</h2>
      <p>
        Selten gehen Pakete verloren oder werden beschädigt. Wenn Ihre Bestellung nicht im erwarteten Zeitraum ankommt oder beschädigt eintrifft, kontaktieren Sie uns bitte sofort. Wir klären den Fall mit dem Transporteur.
      </p>

      <h2>📍 Korrekte Adresse</h2>
      <div class="info-note">
        <strong>Wichtig:</strong> Bitte prüfen Sie, dass Ihre Lieferadresse vollständig und richtig ist. Für Sendungen an eine von Ihnen falsch angegebene Adresse übernehmen wir keine Verantwortung. Adressänderungen bitte so früh wie möglich vor dem Versand mitteilen.
      </div>
    </div>
`;

export const SHIPPING_PAGE_TRANSLATIONS = {
  'fr-CA': {
    title: 'Informations sur la livraison',
    description:
      'Tarifs et délais de livraison. Livraison gratuite au Canada pour les commandes de plus de 50 $.',
    html: frenchShipping,
  },
  'fr-FR': {
    title: 'Informations sur la livraison',
    description:
      'Tarifs et délais de livraison. Livraison gratuite au Canada pour les commandes de plus de 50 $.',
    html: frenchShipping,
  },
  de: {
    title: 'Versandinformationen',
    description:
      'Versandkosten und Lieferzeiten. Kostenloser Versand innerhalb Kanadas ab 50 $.',
    html: germanShipping,
  },
};
